import { useNavigate } from "react-router-dom";
import CardHeaderBackgroundComponent from "../../../components/cardHeaderBackground";
import ContainerComponent from "../../../components/conatiner";
import HeaderComponent from "../../../components/header";
import { ChangeEvent, useEffect, useState } from "react";
import InputComponent from "../../../components/input";
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { FinancialOrdersCostCenterService, FinancialOrdersService } from "../../../services/financial/orders";
import { ToastErro } from "../../../components/toast";
import TableComponent from "../../../components/table";
import moment from "moment";
import { CostCentersService } from "../../../services/center_cost";
import BusinessCardBadgeComponent from "../../../components/businessCardBadge";

const FinancialOrdersPage = () => {

    const navigate = useNavigate();

    const [loadingOrders, setLoadingOrders] = useState<boolean>(true);

    const [orders, setOrders] = useState<any>([]);
    const [costCenters, setCostCenters] = useState<any>([]);

    // variaveis de pesquisa
    const [number, setNumber] = useState<string>('');
    const [date, setDate] = useState<string>('');
    const [costCenter, setCostCenter] = useState<string>('');
    const [status, setStatus] = useState<string>('');
    const [name, setName] = useState<string>('');
    const [page, setPage] = useState<number>(1);
    // variaveis de pesquisa

    // função para pesquisar ordens
    const getOrders = async () => {

        setLoadingOrders(true);

        await FinancialOrdersService(number, date, name, costCenter, status, page).then(resp => {
            setOrders(resp.data);
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
        });

        setLoadingOrders(false);

    }
    // função para pesquisar ordens

    const getCostCenters = async () => {

        await FinancialOrdersCostCenterService().then(resp => {
            setCostCenters(resp.data);
        })

    }

    useEffect(() => {
        getCostCenters();
    }, [])

    useEffect(() => {
        getOrders();
    }, [page]);

    return (
        <>
            <HeaderComponent
                title="Ordens"
            />
            <ContainerComponent>
                <>
                    <CardHeaderBackgroundComponent
                        title="Pesquisar"
                    >
                        <>
                            <div className="row">
                                <InputComponent
                                    label="Número"
                                    col={3}
                                    defaultValue={number}
                                    onChange={(e: ChangeEvent<HTMLInputElement>) => setNumber(e.target.value)}
                                    size={"small"}
                                />
                                <InputComponent
                                    label="Data de Cadastro"
                                    col={3}
                                    defaultValue={date}
                                    onChange={(e: ChangeEvent<HTMLInputElement>) => setDate(e.target.value)}
                                    type={'date'}
                                    size="small"
                                    shrink
                                />
                                <InputComponent
                                    label="Nome"
                                    col={6}
                                    defaultValue={name}
                                    onChange={(e: ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
                                    size={'small'}
                                />
                            </div>
                            <div className="row">
                                <div className="col-md-4 mb-4">
                                    <FormControl
                                        fullWidth
                                        size="small"
                                    >
                                        <InputLabel>Centro de Custo</InputLabel>
                                        <Select
                                            label="Centro de Custo"
                                            value={costCenter}
                                            onChange={(e: SelectChangeEvent) => setCostCenter(e.target.value)}
                                        >
                                            {
                                                costCenters.map((c: any) => {
                                                    return <MenuItem value={c.id}>{c.description}</MenuItem>;
                                                })
                                            }
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="col-md-4 mb-4">
                                    <FormControl
                                        fullWidth
                                        size="small"
                                    >
                                        <InputLabel>Status</InputLabel>
                                        <Select
                                            label="Status"
                                            value={status}
                                            onChange={(e: SelectChangeEvent) => setStatus(e.target.value)}
                                        >
                                            <MenuItem value={2}>Pago</MenuItem>
                                            <MenuItem value={7}>Pendente de Pagamento</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="col-md-4">
                                    <button className="btn btn-primary" type="button" onClick={() => page > 1 ? setPage(1) : getOrders()}>Pesquisar</button>
                                    <button className="btn btn-danger" type="button" style={{ marginLeft: 15 }} onClick={() => (window as any).location.reload()}>Limpar</button>
                                </div>
                            </div>
                        </>
                    </CardHeaderBackgroundComponent>

                    <TableComponent
                        title="Ordens"
                        columns={['Nº da Ordem', 'Usuário', 'Data de Cadastro', 'Enviado ao Financeiro', 'Centro de Custo', 'Valor Total', 'Status', 'Cartão Corporativo', 'Informações']}
                        loading={loadingOrders}
                        page={page}
                        last_page={orders?.last_page}
                        onClickPagination={(e: ChangeEvent<unknown>, value: number) => setPage(value)}
                    >
                        {
                            orders?.data?.map((o: any) => {
                                return (
                                    <tr key={o.id}>
                                        <td className="px-4">{o.id}</td>
                                        <td className="px-4">{o.name}</td>
                                        <td className="px-4">{moment(o.created_at).format("DD/MM/YYYY")}</td>
                                        <td className="px-4">{o.sent_to_financial_at ? moment(o.sent_to_financial_at).format("DD/MM/YYYY HH:mm") : '-'}</td>
                                        <td className="px-4">{o.cost_center}</td>
                                        <td className="px-4">{parseFloat(o.total_value ?? 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                                        <td className="px-4">
                                            {
                                                o.status_id == 2

                                                    ?

                                                    <h6><span className="badge bg-success">{o.status}</span></h6>

                                                    :

                                                    <h6><span className="badge bg-info">{o.status}</span></h6>
                                            }
                                        </td>
                                        <td className="px-4">
                                            <BusinessCardBadgeComponent value={o.payment_business_card} />
                                        </td>
                                        <td className="px-4">
                                            <button className="btn btn-text-info" type="button" title="Informações" onClick={() => navigate(`/financial/orders/${o.id}`)}><i className="material-icons">info</i></button>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </TableComponent>
                </>
            </ContainerComponent>
        </>
    )

}

export default FinancialOrdersPage;